import { Dog, Users, Heart, Shield } from 'lucide-react';
import { SEO } from '@/components/SEO';

export default function AboutPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 animate-fade-in" data-testid="about-page">
      <SEO
        title="About Us"
        description="DoggoHub is the trusted marketplace connecting dog lovers with responsible breeders. Our mission is to make finding your perfect canine companion easy, safe, and joyful."
        keywords="about DoggoHub, dog marketplace, trusted dog breeders, responsible breeding"
      />
      <h1 className="font-['Nunito'] font-extrabold text-3xl sm:text-4xl text-[#1A1D20] tracking-tight mb-6">
        About DoggoHub
      </h1>
      <p className="text-lg text-[#5C636A] leading-relaxed mb-12 max-w-2xl">
        DoggoHub is the trusted marketplace connecting dog lovers with responsible breeders. Our mission is to make finding your perfect canine companion easy, safe, and joyful.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {[
          { icon: Dog, title: 'Trusted Breeders', desc: 'We connect you with verified, responsible dog breeders who prioritize health and well-being.' },
          { icon: Users, title: 'Community First', desc: 'Join thousands of dog lovers sharing experiences, advice, and the joy of dog ownership.' },
          { icon: Heart, title: 'Perfect Matches', desc: 'Our breed matcher helps you find the dog that fits your lifestyle, ensuring happy partnerships.' },
          { icon: Shield, title: 'Safe & Secure', desc: 'Every listing is monitored for quality and legitimacy, keeping our community safe.' },
        ].map((item, i) => (
          <div key={i} className="bg-white rounded-3xl p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
            <item.icon className="w-8 h-8 text-[#4A90E2] mb-4" />
            <h3 className="font-['Nunito'] font-bold text-lg text-[#1A1D20] mb-2">{item.title}</h3>
            <p className="text-sm text-[#5C636A] leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
